// Func = limiting Scope for this file
let lastScrollTop = 0;
let subtleParallaxEvents = [];
let timeout;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const updateAssets = () => {
	const width = window.innerWidth;
	const breakpoint = 768;
	
	if(document.querySelectorAll('.js-responsive-asset').length > 0){
		const assets = document.querySelectorAll('.js-responsive-asset');
		assets.forEach(el => {
			const newSrc = width < breakpoint 
			? el.getAttribute('data-mobile') 
			: el.getAttribute('data-desktop');

			if (newSrc !== '' && newSrc !== el.src) {
				el.src = newSrc;
			}
		});
	}
	if(document.querySelectorAll('.js-gallery-trigger').length > 0){
		if(width < breakpoint){
			document.querySelectorAll('.js-gallery-trigger').forEach(expand => {
				expand.addEventListener('click', (e) => {
					e.preventDefault();
				})
			});
		}
	}

	
};

function resizeWindow(){
	clearTimeout(timeout);
	timeout = setTimeout(updateAssets, 200);
}



(function(){
	let mainGallery = new LBX('.js-full-lbx', {});
	mainGallery.fullScreen = true;

	let contentLbx = new LBX('.lbx-trigger', {});
	contentLbx.fullScreen = window.innerWidth < 768 ? true : false;

	window.onload = function() {
		if(document.querySelector('.js-hero-home') && (document.documentElement.clientWidth > 768)) {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
				
			})
		} else {
			document.querySelector('header').classList.add('down');
		}
		updateAssets();
	};

	window.addEventListener('resize', () => {
		resizeWindow();
		
	});

	// FORM focus animation
	if(document.querySelectorAll('.form-module__field:not(.gdpr)').length > 0){
		document.querySelectorAll('.form-module__field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}
	//Default Signup
	if(document.querySelectorAll('.field:not(.gdpr)').length > 0){
		document.querySelectorAll('.field:not(.gdpr)').forEach(field => {
			const input = field.querySelector('input, textarea, select');
			if (input) {
				input.addEventListener('focus', () => field.classList.add('moved'));
			}
		})
	}

	// Menu trigger
	document.querySelectorAll('.js-menu-trigger').forEach(trigger => {
		trigger.addEventListener('click', () => {
			document.querySelector('.menu-container').classList.add('open');
		})
	})
	document.querySelectorAll('.js-menu-close').forEach(trigger => {
		trigger.addEventListener('click', () => {
			document.querySelector('.menu-container').classList.remove('open');
		})
	})

	if(document.querySelectorAll('.js-category-name').length > 0){
		document.querySelectorAll('.js-category-name').forEach(btn => {
			btn.addEventListener('click', () => {
				const expanded = btn.getAttribute('aria-expanded') === 'true';
				const panel = document.getElementById(btn.getAttribute('aria-controls'));
				btn.setAttribute('aria-expanded', String(!expanded));
				panel.hidden = expanded;
			});
		});
	}

	if(document.querySelectorAll('.js-menu-tab').length > 0){
		
		document.querySelectorAll('.js-menu-tab').forEach(btn => {
			
			btn.addEventListener('click', () => {

				document.querySelectorAll('.js-menu').forEach( panel => {
					panel.hidden = true;
					panel.classList.remove('active');
				});
				document.querySelectorAll('.js-menu-tab').forEach( tab => {
					tab.setAttribute('aria-expanded', 'false');
					tab.classList.remove('active')
				});
				
				const expanded = btn.getAttribute('aria-expanded') === 'true';
				const panel = document.getElementById(btn.getAttribute('aria-controls'));
				btn.setAttribute('aria-expanded', String(!expanded));
				panel.hidden = expanded;
				panel.classList.add('active');
				btn.classList.add('active');
			});
		});
	}

	if(document.querySelectorAll('.js-hero-outlet').length > 0){
		document.querySelectorAll('.js-hero-outlet').forEach((outlet,i) => {
			
			outlet.addEventListener('click', () => {
				let splitLink = outlet.getAttribute('data-link').split(',');
				window.open(splitLink[0],splitLink[1]);
			})
		})
	}
	//js-pin-click
	if(document.querySelectorAll('.js-pin-click').length > 0){
		document.querySelectorAll('.js-pin-click').forEach((outlet,i) => {
			
			outlet.addEventListener('click', () => {
				let action = (outlet.getAttribute('data-link').includes('restaurants')) ? '_blank' : '_self';
				window.open(outlet.getAttribute('data-link'), action);
			})
		})
	}

	//tracking links
	document.querySelectorAll('a').forEach(link => {
		if(link.innerText.includes('Order Online') ){
			link.classList.add('track-order');
		}
	})
	document.querySelectorAll('a').forEach(link => {
		if(link.innerText.includes('View Menus') ){
			link.classList.add('track-menu');
		}
	})

	//Links that open the menus:
	if(document.querySelectorAll('.js-go-to-link').length > 0){
		document.querySelectorAll('.js-go-to-link').forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				let linkTarget = link.getAttribute('href').slice(1);
				
				if(document.querySelector(`#tab${linkTarget}`)){
					document.querySelector('.menus-block').scrollIntoView({ behavior: 'smooth' });
					document.querySelector(`#tab${linkTarget}`).click();
				}
			})
		})
	}

	if(document.querySelector('.js-tabs-arrow')){
		document.querySelector('.js-tabs-arrow').addEventListener('click', (e) => {
			document.querySelector('.js-buttons-container').classList.toggle('open');
		})
		document.querySelectorAll('.js-menu-tab').forEach(link => {
			link.addEventListener('click', (e) => {
				document.querySelector('.js-buttons-container').classList.remove('open');
			})
		})
	}



    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if(document.querySelectorAll('.js-media-observer').length > 0){


		function subtleParallax(el,index){
			let elementAsset = el.querySelector('img') || el.querySelector('video');
			if (!elementAsset) return;

    		let ticking = false;
			let parallaxFunction = () => {
				if (!ticking) {
					window.requestAnimationFrame(() => {
						// 1. Get element position relative to viewport
						const rect = el.getBoundingClientRect();
						const viewportHeight = window.innerHeight;

					
						let progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
						progress = Math.max(0, Math.min(1, progress));

						const maxMove = 25; 
						const move = (progress * maxMove);

						elementAsset.style.transform = `translateY(${move}%)`;
						ticking = false;
					});
					ticking = true;
				}
				
			}

			subtleParallaxEvents[index] = parallaxFunction;
			window.addEventListener('scroll', parallaxFunction);
		} 


		let observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 0.4
		}

		const assetObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				let realIndex = Array.from(document.querySelectorAll('.js-media-observer')).indexOf(entry.target);
				
				if (entry.isIntersecting) {
					entry.target.classList.add('in-viewport');
					subtleParallax(entry.target,realIndex);

				} else {
					entry.target.classList.remove('in-viewport');
					window.removeEventListener('scroll', subtleParallaxEvents[realIndex]);
				}
				});
			}, {
			observerOptions
		});
		document.querySelectorAll('.js-media-observer').forEach(el => assetObserver.observe(el));
	}

})();

function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down'))  {
			document.getElementById('header').classList.add('down');
			
		}
	} else {
		if(document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('down');
			
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}